<template>
    <div>
        <b-modal id="modal-account-expiry" class="maintenance_modal" centered hide-footer :header-bg-variant="'white'"
            header-class="border-none" no-close-on-esc no-close-on-backdrop>
            <template #modal-header="{ close }">
                <b-button size="sm" class="d-none" variant="outline-danger" @click="close()">
                    Close Modal
                </b-button>
            </template>
            <div class="d-block text-center">
                <div v-if="company[0].banners && company[0].banners.show_enterprise_banner">
                    <h3 class="f-18 text-center mb-5 font-weight-bold">
                        {{ $t('accountExpiry.subscriptionExpired', { date: moment.tz(getCompanyTrialDate, userTimeZone).format("ll") }) }}
                    </h3>
                </div>
                <div v-else-if="getStripeStatus">
                    <h3 class="f-18 text-center mb-5 font-weight-bold"
                        v-if="(company[0] && user && company[0].owner && company[0].owner.email === user.email) || $store.state.user && $store.state.user.user && $store.state.user.user.team_member && $store.state.user.user.team_member.role === 'Owner Operator'">
                        {{ $t('accountExpiry.trialExpiredOwner') }}
                    </h3>
                    <h3 class="f-18 text-center mb-5 font-weight-bold" v-else>{{ $t('accountExpiry.trialExpiredMember') }}</h3>
                </div>
                <b-button variant="primary"
                    class="mb-3 schedule-btn text-white h-40px d-flex align-items-center justify-content-center mx-auto"
                    @click="getSubscriptionDetailsUrl()"
                    v-if="(company[0] && user && company[0].owner && company[0].owner.email === user.email && getStripeStatus) || ($store.state.user && $store.state.user.user && $store.state.user.user.team_member && $store.state.user.user.team_member.role === 'Owner Operator')">{{ $t('accountExpiry.yes') }}</b-button>
                <b-button variant="secondary"
                    class="mb-0 schedule-btn h-40px d-flex align-items-center justify-content-center mx-auto"
                    to="/all-companies">{{ $t('accountExpiry.exit') }}</b-button>
            </div>
        </b-modal>
    </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import * as moment from "moment-timezone";
import { clearGleapUser } from "@/plugins/gleap";
export default {
    data() {
        return {
            moment,
            userTimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        }
    },
    name: "Account-Expiry",
    computed: {
        ...mapGetters(["company", "user"]),
        getStripeStatus() {
            return this.company[0]?.subscription?.type === 'Stripe' && this.company[0]?.subscription?.is_in_trial
        },
        getEnterpriseStatus() {
            return this.company[0]?.subscription?.type === 'Enterprise' && this.company[0]?.subscription?.status === 'inactive'
        },
        getCompanyTrialDate() {
            return this.company[0]?.subscription?.trial_end || this.company[0]?.trial_ends_at
        }
    },
    methods: {
        ...mapActions(['logoutUser', "getSubscriptionDetails","createUserLogs"]),
        async getSubscriptionDetailsUrl() {
            try {
                const url = await this.getSubscriptionDetails();
                if (url) window.location.href = url
            }
            catch (e) {
                console.log(e)
            }
        },
        async logout() {
            await this.createUserLogs({ action: 'logout' });
            this.logoutUser();
            if(!process.env.VUE_APP_SHOW_INTERCOM) {
            clearGleapUser();
            }
            this.$router.push("/login");
        },
    },
}
</script>